import { render, staticRenderFns } from "./ReportDownloads.vue?vue&type=template&id=619704a8&"
import script from "./ReportDownloads.vue?vue&type=script&lang=js&"
export * from "./ReportDownloads.vue?vue&type=script&lang=js&"
import style0 from "./ReportDownloads.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports